<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Indicador de CO4</div>

            <b-form-group
              label="Período"
              label-for="periodo"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="indicadorSemestreNombre" 
                :options="semestres" 
                :state="periodoValido"
                class="mb-3 select-fecha select-fecha-mes"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null">Seleccione un semestre</option>
                </template>
              </b-form-select>

              <b-form-select 
                v-model="indicadorAnio" 
                :options="anios" 
                :state="periodoValido"
                class="mb-3 select-fecha select-fecha-anio"
                @blur.native="validate">
                <template slot="first">
                  <option :value="null">Seleccione un año</option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback id="indicadorAnioFeedback">
                {{ periodoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Fecha Vigencia - Desde"
              label-for="fechaVigenciaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaDesde" 
                v-model="fechaVigenciaDesde" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Vigencia - Hasta"
              label-for="fechaVigenciaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaVigenciaHasta"
                v-model="fechaVigenciaHasta" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Pje.Objetivo"
              label-for="pjeObjetivo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeObjetivo"
                v-model.trim="$v.pjeObjetivo.$model" 
                :state="pjeObjetivoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeObjetivoFeedback">
                {{ pjeObjetivoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripcion"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="descripcion"
                v-model.trim="$v.descripcion.$model" 
                :state="descripcionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { decimal, maxLength, minValue } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'indicadorPorcentaje/getField',
  mutationType: 'indicadorPorcentaje/updateField',
});

export default {
  name: 'IndicadorRSEABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      pjeObjetivoValido: null,
      pjeObjetivoInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      semestres: [],
      anios: [],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaVigenciaDesde',
      'fechaVigenciaHasta',
      'indicadorSemestre',
      'indicadorSemestreNombre',
      'indicadorAnio',
      'pjeObjetivo',
      'descripcion'    
    ]),
  },
  created() {
    let indicadorId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        indicadorId = this.$route.params.id;
      }
    }

    this.semestres = ['1er Semestre', '2do Semestre'];
    this.anios = this.getAniosPeriodo();

    let params = {
      controller: 'indicadores-rse',
      indicadorId
    }

    this.showSpinner();
    this.$store.dispatch('indicadorPorcentaje/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());    
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pjeObjetivo' || validarTodos) {
        if (this.$v.pjeObjetivo.$error) {
          this.pjeObjetivoValido = false;
          if (!this.$v.pjeObjetivo.decimal) {
            this.pjeObjetivoInvalidoMsj = 'El porcentaje debe ser un valor numérico';
          } else {
            if (!this.$v.pjeObjetivo.minValue) {
              this.pjeObjetivoInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }     
        } else {
          this.pjeObjetivoValido = null;
          this.pjeObjetivoInvalidoMsj = '';
        }
      }

      if (campo == "descripcion" || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripcion sólo pueden contener hasta 50 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      if (this.indicadorSemestreNombre == null || this.indicadorAnio == null) {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período correspondiente';
        save = false;
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('indicadorPorcentaje/save')
            .then( () => this.showModalMsj ('La información del indicador se actualizó con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: 'IndicadoresRSE' });
    },
  },
  validations: {
    pjeObjetivo: { 
      decimal, 
      minValue: minValue(0) },
    descripcion: {
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
  #descripcion {
    text-transform: none;
  }
</style>
